const tutorials = {
    'overview': [
        
        {
            target: ".sectionBody.isTable",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Manage Events</h2>
                    <p>
                        This is your control center for creating and managing events. All events you are a part of will be listed here.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'bottom',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".viewTabs",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Organize Your Workspace</h2>
                    <p>
                        These are called views, they are tabs you can use to organize your events. You can create custom views to filter events based on your preferences. You can also set a default view to prioritize the events you work on the most.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".mainActionContainer",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Add Events</h2>
                    <p>
                        Use this button to create a new event. If you have existing events you will have the option to duplicate them aswell.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'right',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    top: '55px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".viewSearch",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Search Table</h2>
                    <p>
                        Start typing to quickly search for events. You can search by any toggled column in the table.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".viewFilterButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Filter Rows</h2>
                    <p>
                        Here you can use filter events based on custom filters, you can combine multiple filters to get the exact list of events you are looking for.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".columnToggleButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Manage Columns</h2>
                    <p>
                        Here you can manage the columns you see in the table. You can order, toggle or even add new columns to the table.
                        New columns will become custom fields you can use for filtering or data tracking.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: "#downloadTable",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Download Table</h2>
                    <p>
                        Use this button to download the table as a CSV file. This is useful for sharing data or creating reports.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".searchButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Quick Search</h2>
                    <p>
                        Easily search through all your events for any event related data to quickly find what you are looking for.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".notificationsButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Platform Notifcations</h2>
                    <p>
                        View all notifications from the platform here. You can subscribe to specific event data, like attendees or sessions to keep informed of changes made at any time.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".inboxButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Task Inbox</h2>
                    <p>
                        Keep track of tasks accross all of your events. Tasks are created within event sessions to help you coordinate your staff.
                    </p>
                </div>
            ),
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".contactsNavButton",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Access Contacts</h2>
                    <p>
                        View all contacts you have added to the platform. All attendees will become contacts but you can also add custom contacts to keep track of all your event stakeholders.
                    </p>
                </div>
            ),
            locale: { last: "Got it, I'm ready" },
            disableBeacon: true,
            placement: 'top',
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
    ],
    'event': [
        {
            target: ".menuItem.details",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-info-circle toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Event Setup</h2>
                    </div>
                    <p className='mb-15'>This is your control center for customizing every aspect of your event.</p>
                    <p className='mb-15'><strong className='blockHeader'>Event Details:</strong> Adjust core event information anytime.</p>
                    <p><strong className='blockHeader'>Brand Your Event:</strong> Upload your company logo, banner, and set brand colors.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }

        },
        {
            target: ".menuItem.attendees",
            content: (
                <div className='StepsBox'>
                    <div className='flex'>
                        <i className="las la-user-friends toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Attendee Management</h2>
                    </div>
                    <p className='mb-15'>Your central hub for managing all event participants, from invitation to check-in.</p>
                    <p className='mb-15'><strong className='blockHeader'>Track Attendees:</strong> View and monitor registration status.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Actions:</strong>Add attendees, assign groups, schedule sessions.</p>
                    <p><strong className='blockHeader'>Power Tools:</strong> Bulk import, custom filters, and export options.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '110px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }

        },
        {
            target: ".menuItem.schedule",
            disableBeacon: true,
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-calendar-week toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Session Management</h2>
                    </div>
                    <p className='mb-15'>Create and manage all your event sessions - from keynotes to workshops and breakouts.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Setup:</strong> Start with basic details - name, date, time, and session type.</p>
                    <p className='mb-15'><strong className='blockHeader'>Manage Participation: </strong>Add attendees, groups, and speakers to any session. </p>
                    <p className='mb-15'><strong className='blockHeader'>Engagement Tools: </strong> Enhance sessions with polls, surveys, and reviews. </p>
                    <p className='mb-15'><strong className='blockHeader'> Smart Organization: </strong>  Use filters to manage concurrent sessions and create custom views.</p>
                    <p className='proTipColor small' > Pro tip: Save time by copying an existing session - it duplicates all details, including polls and surveys.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '140px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.groups",
            disableBeacon: true,
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-users toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Group Management</h2>
                    </div>
                    <p className='mb-15'>Organize your attendees into custom groups to streamline event management.</p>
                    <p className='mb-15'><strong className='blockHeader'>Flexible Grouping: </strong> Create custom groups like onsite or virtual attendees</p>
                    <p className='mb-15'><strong className='blockHeader'>Easy Assignment: </strong>Add attendees and sessions to any group </p>
                    <p className='mb-15'><strong className='blockHeader'>Smart Control: </strong> Set capacity limits and manage group size.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Access:</strong> Use custom views and filters to track groups</p>
                    <p className='proTipColor small' > Pro tip: Export group data anytime to get quick insights about attendance and session distribution.</p>
                </div>
            ),
            placement: "right",
            locale: { skip: "Skip For Now" },
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '145px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.emails",
            disableBeacon: true,
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-envelope toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Email Campaigns</h2>
                    </div>
                    <p className='mb-15'>Create and manage all your event communications with powerful email tools.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Access:</strong>  Use templates for registrations, reminders, and surveys. </p>
                    <p className='mb-15'><strong className='blockHeader'>Custom Design:</strong>Build beautiful emails with our visual editor.</p>
                    <p className='mb-15'><strong className='blockHeader'>Automation:</strong>Schedule emails or set up trigger-based sending.</p>
                    <p className='mb-15'><strong className='blockHeader'>Track Success:</strong>Monitor sent metrics for your campaigns.</p>
                    <p className='proTipColor small' >Pro tip: Save time by creating your own templates for frequently used email types.</p>
                </div>
            ),
            placement: "right",
            locale: { skip: "Skip For Now" },
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '140px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.pages",
            disableBeacon: true,
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Website Page Builder</h2>
                    </div>
                    <p className='mb-15'>Create stunning event pages with our intuitive drag-and-drop builder.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Start:</strong> Choose from templates like agenda, check-in, and session registration.</p>
                    <p className='mb-15'><strong className='blockHeader'>Custom Build:</strong>Create pages from scratch with drag-and-drop components. </p>
                    <p className='mb-15'><strong className='blockHeader'>Device Ready</strong> Preview and optimize for both desktop and mobile.</p>
                    <p className='mb-15'><strong className='blockHeader'>Access Control:</strong>Set pages as public, private, or password-protected. </p>
                    <p className='proTipColor small' > Pro tip: Save frequently used components as global elements to reuse across multiple pages.</p>

                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.mobile",
            disableBeacon: true,
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Mobile App Configuration</h2>
                    </div>
                    <p className='mb-15'>Enable and customize your event's mobile experience with an easy-to-use configuration panel.</p>
                    <p className='mb-15'><strong className='blockHeader'>Screen Setup:</strong>  Enable key features like home, agenda, maps, and speakers. </p>
                    <p className='mb-15'><strong className='blockHeader'>Brand Identity:</strong> Customize with your logo, colors, icons, and fonts.</p>
                    <p className='mb-15'><strong className='blockHeader'>Navigation: </strong>Arrange and order screens in the app's navigation bar. </p>
                    <p className='mb-15'><strong className='blockHeader'>Live Preview: </strong>See your changes in real-time with the app preview. </p>
                    <p className='proTipColor small'>Pro tip: Set up your screens and navigation first, then customize each screen's components for the best workflow. </p>
                </div>
            ),
            locale: { last: "Next" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                }
            }
        },
    ],
    'Emails': [
        {
            target: ".mainAction",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-envelope toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Email Campaign Builder</h2>
                    </div>
                    <p className='mb-20'>This is where you can create custom emails to engage your event attendees at different stages - from promotion to post-event follow up.</p>
                    <p className='mb-15'>Get started by selecting one of our pre-built email templates or build your own from scratch.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'EmailTemplateCenter': [
        {
            target: ".sideNav.selectedInverted",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-envelope toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Choose an Email Template</h2>
                    </div>
                    <p className='mb-20'>Our templates cover common use cases like event promotion, registration confirmation, and post-event surveys.</p>
                    <p className='mb-15'>Each template is fully customizable, so feel free to modify the content and design to match your event.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'Pages': [
        {
            target: ".mainAction",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Website Page Builder</h2>
                    </div>
                    <p className='mb-20'>Create a complete event website by building individual pages for your event - from home page to agenda to registration.</p>
                    <p className='mb-20'>Start with our pre-built templates or create your own custom pages from scratch.</p>
                </div>
            ),
            locale: { last: "Got it" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                    top:"75px"
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'PagesTemplateCenter': [
        {
            target: ".sideNav.selectedInverted",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Choose Your Page Type</h2>
                    </div>
                    <p className='mb-20'>Select from different page types like Home, Agenda, Registration, Maps, and more.</p>
                    <p className='mb-20'>Each template is pre-configured with recommended components for that page type.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, 
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'Page': [
        {
            target: ".neu.min.ml-a ",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Customize Page</h2>
                    </div>
                    <p className='mb-20'>Use our intuitive drag & drop builder to add, remove, or rearrange components on your page.</p>
                    <p className='mb-20'>Your event branding and colors from the setup process will automatically be applied.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "left",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".mainAction.prim",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Preview And Publish</h2>
                    </div>
                    <p className='mb-20'>Make adjustments in real-time before publishing your changes.</p>
                    <p className='mb-20'>Your pages will automatically update for all attendees when published.</p>
                </div>
            ),
            locale: { last: "Got It", skip: "Skip For Now" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '50px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
    ],
    
    'PageEditDesign': [
        {
            target:".w-100.h-100.flex-ac.c-pointer",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Essential Components</h2>
                    </div>
                    <p className='mb-20'>Add event-specific components like:</p>
                    <ul>
                        <li>Featured Sessions to highlight key talks</li>
                        <li>Registration Forms for attendee sign-up</li>
                        <li>Agenda Tabs to organize multi-day schedules</li>
                        <li>QR Code scanners for check-in</li>
                    </ul>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".deviceWidthButton",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Mobile Ready Design</h2>
                    </div>
                    <p className='mb-20'>Preview how your pages look on desktop, tablet, and mobile devices. </p>
                    <p className='mb-20'>All components automatically adjust for the best experience on any screen size. </p>
                </div>
            ),
            placement: "bottom",
            disableBeacon: true,
            locale: { skip: "Skip For Now" },
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: '.flex.column.jcc.aic.c-pointer.library',
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Link your Pages</h2>
                    </div>
                    <p className='mb-20'>Connect your pages using the Navigation Bar component. </p>
                    <p className='mb-20'>Create a cohesive website experience for your attendees.</p>
                    <p className='mb-20'>Easily manage navigation between Home, Agenda, Registration, and other pages.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '30px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
    ],

    'Forms': [
        {
            target: ".mainActionContainer",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="lab la-wpforms toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Form Builder</h2>
                    </div>
                    <p className='mb-15'>Create custom forms to add to your event website. Choose from our templates or build from scratch to collect exactly what you need.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '50px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'FormTemplateCenter': [
        {
            target: ".sideNav.selectedInverted",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="lab la-wpforms toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Form Builder</h2>
                    </div>
                    <p className='mb-15'>Create custom forms to add to your event website. Choose from our templates or build from scratch to collect exactly what you need.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'Form': [
        {
            target: ".neu.ml-a",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="lab la-wpforms toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Customize Your Form</h2>
                    </div>
                    <p className='mb-15'>Click 'Edit Form' to begin customizing your form layout and components.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "left",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '30px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".prim",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-laptop-code toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Add to Page</h2>
                    </div>
                    <p className='mb-15'>Click 'Add to Page' to publish your form. Select a webpage to display your registration form to attendees.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        }
    ],
    'FormEditor': [
        {
            target: ".flex.column.jcc.aic.c-pointer.editor",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="lab la-wpforms  toolTipIconmr-10"></i>
                        <h2 className="blockHeader">Form Components</h2>
                    </div>
                    <p className='mb-20'>Drag and drop components to build your form. </p>
                    <p className='mb-20'>For attendee info, use validated fields like Email and Phone to ensure correct data collection. </p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '30px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
    ],
    'Mobile': [
        {
            target: ".tabItem.selected",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Setup App Screens</h2>
                    </div>
                    <p className='mb-20'>Build your perfect event app by choosing from pre-built pages and custom website content. </p>
                    <p className='mb-20'>Use the design preview to experience the app flow exactly as your attendees will see it. </p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "bottom",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".tabItem:nth-child(2)",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Build Customization</h2>
                    </div>
                    <p className='mb-20'>Personalize each section of your app with custom messaging and features that resonate with your audience.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "bottom",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".tabItem:nth-child(3)",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Customize Branding & Design</h2>
                    </div>
                    <p className='mb-20'>Make the app yours with custom styling that matches your event's identity. Fine-tune visual elements for a cohesive brand experience.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "bottom",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".tabItem:nth-child(4)",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Configure Your App</h2>
                    </div>
                    <p className='mb-20'>Setup your core app specifications and installation settings. Define how your app appears on devices and during installation.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "bottom",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
        {
            target: ".tabItem:nth-child(5)",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                    <i className="las la-mobile toolTipIcon mr-10"></i>
                        <h2 className="blockHeader">Deploy With Ease</h2>
                    </div>
                    <p className='mb-20'>Launch your mobile app with confidence using our streamlined deployment process. Ensure every attendee has smooth access to your event app.</p>
                </div>
            ),
            locale: { last: "Got It" },
            placement: "bottom",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                    right: 3,
                }
            }
        },
    ],
    'programOverview': [
        
        {
            target: ".mainActionContainer",
            content: (
                <div className="StepsBox">
                    <h2 className='mb-20 semibold'>Let's create your first program</h2>
                    <p>Start by clicking the "Add New Program" button. We'll guide you step-by-step through setting up your program.</p>
                </div>
            ),
            locale: { last: 'Got it' },
            disableBeacon: true,
            placement: 'right',
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '55px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
    ],
    'program': [
        {
            target: ".menuItem.overview",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-stream mr-10"></i>
                        <h2 className="blockHeader">Program Setup</h2>
                    </div>
                    <p className='mb-10'>Your command center for creating and managing recurring events. Set the foundation for seamless event access and management.</p>
                    <p className='mb-10'><strong className='blockHeader'>Track Details:</strong> Event timing, location, and core requirements.</p>
                    <p className='mb-10'><strong className='blockHeader'>Quick Setup: </strong> Branding options and access level controls.</p>
                    <p className='mb-10'><strong className='blockHeader'>Essential Tools: </strong> Template selection and program customization</p>
                    <p className='small proTipColor'>Pro tip: Take time to set up your essential fields first - it'll make managing attendee requests much easier later.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            disableBeacon: true,
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '75px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }

        },
        {
            target: ".menuItem.details",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-pen-alt mr-10"></i>
                        <h2 className="blockHeader">Program Details</h2>
                    </div>
                    <p className='mb-10'>Start by setting up your program basics. You'll need to specify event time, location, and attendee requirements. </p>
            
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '50px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }

        },
   
        {
            target: ".menuItem.emails",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-envelope mr-10"></i>
                        <h2 className="blockHeader">Email Campaigns</h2>
                    </div>
                    <p className='mb-10'>Streamline your communication with automated email flows for every program touchpoint.</p>
                    <p className='mb-10'>Track Emails:<strong className='blockHeader'></strong>Monitor delivery and engagement.</p>
                    <p className='mb-10'>Quick Setup:<strong className='blockHeader'></strong>Pre-built templates for common scenarios.</p>
                    <p className='mb-10'>Power Tools:<strong className='blockHeader'></strong>Custom rules and trigger conditions.</p>
                    <p className='proTipColor small' >Pro tip: Take time to set up your essential fields first - it'll make managing attendee requests much easier later.</p>
                </div>
            ),
            placement: "right",
            locale: { skip: "Skip For Now" },
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '140px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.forms",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="lab la-wpforms mr-10"></i>
                        <h2 className="blockHeader">Forms Setup</h2>
                    </div>
                    <p className='mb-10'>Design how potential attendees will request access to your program. Create a smooth application process that captures all needed information.</p>
                    <p className='mb-10'>Form Builder:<strong className='blockHeader'></strong>Drag and drop custom fields.</p>
                    <p className='mb-10'>Quick Tools:<strong className='blockHeader'></strong>Template library and field validation.</p>
                    <p className='mb-10'>Power Features:<strong className='blockHeader'></strong>Conditional logic and required fields.</p>
                    <p className='proTipColor small' >Pro tip: Keep your form focused - only ask for information you'll use in the approval process.</p>
                </div>
            ),
            placement: "right",
            locale: { skip: "Skip For Now" },
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    top: '140px',
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.requests",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="lab la-wpforms mr-10"></i>
                        <h2 className="blockHeader">Requests Management</h2>
                    </div>
                    <p className='mb-15'>Your central dashboard for handling incoming program requests. Review, approve, and manage attendee applications efficiently.</p>
                    <p className='mb-15'><strong className='blockHeader'>Track Requests:</strong>Monitor pending and approved applications.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Actions:</strong>One-click approve/deny, custom response messages.</p>

                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330,
                    borderRadius:15,
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                },
                buttonClose: {
                    top: 7,
                }
            }
        },
        {
            target: ".menuItem.calendars",
            content: (
                <div className='StepsBox'>
                    <div className='StepBoxIcon'>
                        <i className="las la-calendar-week mr-10"></i>
                        <h2 className="blockHeader">Calendars</h2>
                    </div>
                    <p className='mb-15'>Define when and how attendees can request program access. Set availability that works for your team.</p>
                    <p className='mb-15'><strong className='blockHeader'>Track Times</strong> View and manage available slots.</p>
                    <p className='mb-15'><strong className='blockHeader'>Quick Actions:</strong>Block off dates, set recurring availability.</p>
                    <p className='mb-20'><strong className='blockHeader'>Power Tools:</strong>Multi-calendar support and timezone handling</p>
                    <p className='proTipColor small'>Pro tip: Block off buffer time between requests to allow for preparation and potential overruns.</p>
                </div>
            ),
            locale: { skip: "Skip For Now" },
            placement: "right",
            styles: {
                tooltipContent: {
                    padding: 0, // Ensures no padding inside the content area
                },
                tooltip: {
                    padding: "20px",
                    width: 330
                },
                buttonBack: {
                    display: "none",
                },
                buttonSkip: {
                    position: "absolute",
                    right: 85,
                    bottom: 18,
                }
            }
        },
    ]
}

export default tutorials;